const invoices = '/invoices';
const invoice = '/invoice';

export const {getInvoiceInfo, getPaymentInvoiceInfo} = {
    getInvoiceInfo: reference => `${invoices}/${reference}/info`,
    getPaymentInvoiceInfo: reference => `${invoice}/${reference}/info`,
};
